import React from "react";
import { KuikaTag } from "../../../../ui-kit/kuika-tag/kuika-tag";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

export const TagStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Tag"
      componentName="KuikaTag"
      sourcePath="ui-kit/kuika-tag"
      description="Inline hashtag-style label. The 'type' string drives the visual variant via a BEM modifier."
    >
      <SpecRow label="Type variants" caption="default (unstyled) · action">
        <KuikaTag type="default" label="design" />
        <KuikaTag type="action" label="run" />
      </SpecRow>
      <SpecRow label="Long labels">
        <KuikaTag type="default" label="needs-followup" />
        <KuikaTag type="action" label="reset-to-default" />
      </SpecRow>
      <SpecRow label="Middle truncation" caption='truncate="middle" — clipped in the middle, the end survives'>
        <span style={{ display: "inline-flex", width: 120 }}>
          <KuikaTag type="action" label="CUSTOMER_SELECTED_ID" truncate="middle" />
        </span>
      </SpecRow>
      <SpecRow label="In context">
        <span
          style={{ display: "inline-flex", gap: 8, alignItems: "center", color: "var(--lab-ink-muted)", fontSize: 13 }}
        >
          updated 2 days ago
          <KuikaTag type="default" label="auto" />
          <KuikaTag type="action" label="ci" />
        </span>
      </SpecRow>
    </ShowcaseFrame>
  );
};
